import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './Container.css';

const Container = ({ children }) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <div className="container">
        {children}
      </div>
    </DndProvider>
  );
}

export default Container;